import styled from 'styled-components';

import InfoModal from '@components/ui/modals/InfoModal';
import Button from '@components/Button/next';
import { Row } from '@components/formStyles';
export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  padding: 0px;
  @media (min-width: 600px) {
    border: solid 1px ${({ theme }) => theme.palette.gray87};
    padding: 40px 20px 20px 26px;
  }
`;
export const WrapperDesktop = styled.div`
  width: 100%;
  height: auto;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  padding: 0px;
`;
export const WarningBoxWrapper = styled.div`
  max-width: 45%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px auto;
    max-width: 95%;
  }
`;

export const DiscountedDiv = styled.div`
  margin-bottom: 20px;
  margin-top: 10px;
  margin-left: 10px;
`;

export const TitleName = styled.h3`
  font-size: 24px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
  width: 630px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    font-size: 20px;
    width: 230px;
  }
`;
export const Text = styled.span<{
  bold?: boolean;
  size?: number;
  opacity?: number;
}>`
  font-size: ${({ size }) => size || 20}px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: ${({ opacity }) => opacity};
`;

export const PriceBoxWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
`;
export const PriceBoxWrapperDesktop = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
`;

export const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
  gap: 5px;
  border-radius: 8px;
`;

export const BoxWrapperDesktop = styled.div`
  display: flex;
  flex: 1;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;

export const Box = styled.div`
  padding: 3px 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  width: 100%;
  height: auto;
  padding-right: 30px;
  display: block;
`;
export const BoxDesktop = styled.div`
  padding: 3px 8px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  width: fit-content;
  height: auto;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
`;

export const ResponsiveBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Actions = styled.div`
  width: 100%;
  max-height: 40px;
  display: block;
  margin: 0;

  button {
    height: 100%;
    font-weight: 700;
    font-size: 18px;
    margin: 0;
  }
`;
export const ActionsDesktop = styled.div`
  width: 170px;

  button {
    height: 100%;
    font-weight: 700;
    font-size: 18px;
  }
`;

export const Count = styled(Text)`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  position: absolute;
  right: 43px;
`;

export const StyledButton = styled(Button)<{ selected: boolean }>`
  width: 100%;
  height: 45px;
  margin-left: -5px;
  margin-top: 60px;
  font-weight: bold;
  font-size: 14px;

  @media (max-width: 600px) {
    margin-top: 30px;
    margin-bottom: 40px;
  }

  ${({ selected, theme }) =>
    selected &&
    `border: 1px solid ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    pointer-events: none !important;
    
    `}
`;
export const StyledButtonDesktop = styled(Button)<{ selected: boolean }>`
  height: 50px;
  font-weight: bold;
  font-size: 14px;
  margin-left: 0px;
  max-width: 142px;

  ${({ selected, theme }) =>
    selected &&
    `border: 1px solid ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    pointer-events: none !important;
    
    `}
`;

export const DynamicRow = styled(Row)`
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Line = styled.div`
  border-top: solid 1px ${({ theme }) => theme.palette.lightBlueGrey};
  margin: 23px 0 20px;
`;

export const TourCardDatesPoints = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  padding: 0 15px 20px;
  margin-top: 20px;
`;
export const DesktopTourCardDatesPoints = styled.div`
  padding: 0 0 20px 45px;
  margin-top: 41px;
`;

export const TourPointsDate = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
  display: inline-block;
  margin-right: 10px;
`;
export const NotAvailabilityText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media (max-width: 1215px) {
    font-size: 13px;
  }
`;
export const TourPointsText = styled.span``;
export const TourCardDatesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 40px;
  padding: 40px 30px 35px 45px;
  border-top: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  border-bottom: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  margin-top: 40px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 20px 15px;
    margin-top: 20px;
  }
`;
export const TourCardDatesItem = styled.div`
  &:first-of-type {
    border-right: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    &:first-of-type {
      border-right: none;
      margin-right: 0;
    }
  }
`;

export const StyledInfoModal = styled(InfoModal)`
  max-width: 600px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100vw !important;
    position: fixed;
    top: 0;
    left: 0;
  }
`;

export const NewRoomButton = styled.button<{ isDisabled: boolean }>`
  height: 40px;
  width: 155px;
  margin: 30px auto;
  background-color: ${({ theme }) => theme.palette.darkGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  border: none;
  border-radius: 8px;
  opacity: ${({ isDisabled }) => (isDisabled ? '0.7' : '1')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;

export const NewRoomButtonLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.white};
  margin-left: -10px;
`;

export const LimitSeturPointsWrapper = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 30px;
  }
`;
export const OriginalPricePackageContainer = styled.span<{
  size: number;
  noLine?: boolean;
}>`
  color: ${({ theme }) => theme.palette.pinkSwan};
  text-decoration: ${({ noLine }) => !noLine && 'line-through'};
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.6px;
  font-weight: 600;
`;
export const DiscountedPricePackageContainer = styled.span<{
  size: number;
  noLine?: boolean;
}>`
  color: ${({ theme }) => theme.palette.black};
  text-transform: uppercase;
  font-size: 20px;
  letter-spacing: 0.6px;
  font-weight: 700;
`;
export const TourCardText = styled.span<{
  size: number;
  weight: number | string;
}>`
  font-size: ${({ size }) => `${size}px`};
  font-weight: ${({ weight }) => weight};
  color: ${({ theme }) => theme.palette.darkGrey};
`;
export const WrapperDiscount = styled.div``;

export const DiscountedWrapper = styled.div`
  width: fit-content;
  height: auto;
  opacity: 0.9;
  border-radius: 1.7px;
  border: dotted 0.5px ${({ theme }) => theme.palette.darkSuccess};
  background-color: ${({ theme }) => theme.palette.lightSuccess};
`;
export const DiscountedText = styled.span`
  font-size: 11px;
  font-weight: 900;
  text-align: center;
  color: ${({ theme }) => theme.palette.darkSuccess};
  padding: 30px 30px 30px 30px;
`;
